module.exports = __webpack_public_path__ + "static/media/raise-hand-solid.069ea285.svg";